import React from "react";
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import '../header/header.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { HashLink } from "react-router-hash-link";

export default function Header() {
    return (
        <div className="header py-2">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Navbar expand="lg">
                            <Navbar.Brand href="/"><img src="/assets/images/volt.png" alt="" className="" style={{ height: "45px", width: "129px" }} /></Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-dark" />
                            <Navbar.Collapse id="basic-navbar-nav" className="navbar-dark">
                                <Nav className="ms-auto me-0">
                                    <Nav.Link as={HashLink} smooth to="/#volt-section">
                                        About
                                    </Nav.Link>

                                    <Nav.Link as={HashLink} smooth to="/#Assessment-Format">
                                        Assessment Format
                                    </Nav.Link>

                                    <Nav.Link as={HashLink} smooth to="/#reward">
                                        Rewards
                                    </Nav.Link>

                                    <Nav.Link as={HashLink} smooth to="/#how-it-works-section">
                                        How it Works
                                    </Nav.Link>

                                    <Nav.Link as={HashLink} smooth to="/#faq">
                                        FAQ's
                                    </Nav.Link>

                                    <Nav.Link as={HashLink} smooth to="/#footer">
                                        Contact
                                    </Nav.Link>
                                    {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                                        <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.2">
                                            Another action
                                        </NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item href="#action/3.4">
                                            Separated link
                                        </NavDropdown.Item>
                                    </NavDropdown> */}
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                    </div>
                </div>
            </div>
        </div>
    );
}